import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=25e1e321&"
import script from "./Memory.vue?vue&type=script&lang=js&"
export * from "./Memory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports